// extracted by mini-css-extract-plugin
module.exports = {"videoActivityCard":"style-module__videoActivityCard___lY45E"};